var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03325 15.5165V14.1831H12.8499V13.2831H10.1833V7.76647H12.8499V7.01647C12.8499 5.68314 12.3805 4.53592 11.4416 3.5748C10.5027 2.61369 9.36381 2.13314 8.02492 2.13314C6.70825 2.13314 5.56659 2.61369 4.59992 3.5748C3.63325 4.53592 3.14992 5.68314 3.14992 7.01647V7.76647H5.81659V13.2831H1.58325V7.01981C1.58325 6.13358 1.75375 5.29825 2.09475 4.51381C2.43575 3.72936 2.89697 3.04236 3.47842 2.4528C4.05986 1.86325 4.74314 1.39869 5.52825 1.05914C6.31325 0.719582 7.14925 0.549805 8.03625 0.549805C8.92314 0.549805 9.75547 0.719249 10.5333 1.05814C11.311 1.39703 11.9894 1.85919 12.5683 2.44464C13.1473 3.03008 13.6028 3.71403 13.9349 4.49647C14.2671 5.27892 14.4333 6.11892 14.4333 7.01647V15.5165H8.03325ZM3.14992 11.6998H4.24992V9.3498H3.14992V11.6998ZM11.7666 11.6998H12.8499V9.3498H11.7666V11.6998Z",
    fill: "#172128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0a0a86e45415b83463553619b2f6b46e.svg";
export { ForwardRef as ReactComponent };